<template>
	<div>
		<div class="p-3 test-box-shadow border rounded-6 mb-3">
			<div class="border-bottom pb-2">
	      <p class="mb-1 sub-heading-1-1 color-black text-truncate">{{ticket.name}}</p>
	      <template v-if="getMerchant().merchant_category_name == 'ACTIVITIES'">
		      <div class="py-1">
		        <img src="../../assets/img/icon/history.png" class="d-inline-block" width="17">
		        <p class="ml-2 d-inline-block body-2-1 mb-0 color-bold-light" v-if="ticket.variants[0].is_refundable">{{$t('merchant.refundable')}}</p>
		        <p class="ml-2 d-inline-block body-2-1 mb-0 color-bold-light" v-else>{{$t('merchant.non-refundable')}}</p>
		      </div>
		      <div class="py-1">
		      	<template v-if="show_validity_term">
		          <img src="../../assets/img/icon/refound.png" class="d-inline-block align-middle mr-2" width="17">
		          <div class="d-inline-block align-middle w-85">
		          	<p class="body-2-1 d-block mb-0 color-bold-light text-truncate">{{ticket.variants[0].validity_term}}</p>
		          </div>
		      	</template>
		      	<div class="text-right mt-2">
		          <p class="body-2-4 text-green mb-0 color-bold-light cursor-pointer" @click="goDetail()">{{$t('merchant.more-detail')}}</p>
		        </div>
		      </div>
		    </template>
		    <template v-else>
		    	<div class="row no-gutters align-items-center">
		    		<div class="col-1 text-center">
		    			<img src="../../assets/img/icon/dot-blue.png" width="10" class="mb-1">
		    		</div>
		    		<div class="col-2">
		    			<p class="body-2-4 mb-0">{{formatTime(ticket.variants[0].route_from_time)}}</p>
		    		</div>
		    		<div class="col-9">
		    			<p class="body-2 mb-1">{{ticket.variants[0].route_from.name}}</p>
		    		</div>
		    	</div>
		    	<div class="row no-gutters">
		    		<div class="col-1 text-center">
		    			<div class="mx-auto destinations-dot"></div>
		    		</div>
		    		<div class="col-11">
		    			<p class="body-3 mb-0 mt-2">
		    				<template v-if="formatDuration(ticket.variants[0].route_from_time,ticket.variants[0].route_to_time,'H') > 0">
		    					{{formatDuration(ticket.variants[0].route_from_time,ticket.variants[0].route_to_time,'H')}} {{$t('general.hours')}}
	    					</template>
	    					<template v-if="formatDuration(ticket.variants[0].route_from_time,ticket.variants[0].route_to_time,'m') > 0">
	    						{{formatDuration(ticket.variants[0].route_from_time,ticket.variants[0].route_to_time,'m')}} {{$t('general.minutes')}}
	    					</template>
	    				</p>
		    		</div>
		    	</div>
		    	<div class="row no-gutters align-items-center" :class="{'mb-2': !show_variant && return_custom_show}">
		    		<div class="col-1 text-center">
		    			<img src="../../assets/img/icon/pin.png" width="16" class="mb-1">
		    		</div>
		    		<div class="col-2">
		    			<p class="body-2-4 mb-0">{{formatTime(ticket.variants[0].route_to_time)}}</p>
		    		</div>
		    		<div class="col-9">
		    			<p class="body-2 mb-1">{{ticket.variants[0].route_to.name}}</p>
		    		</div>
		    	</div>
		    	<div class="w-100 d-table">
		    		<!-- <p v-if="!show_variant && return_custom_show" class="body-2-4 text-orange mb-0 color-bold-light cursor-pointer d-table float-left" @click="goDetail()">Change Variant</p> -->
		    		<p class="body-2-4 text-green mb-0 color-bold-light cursor-pointer d-table float-right" @click="goDetail()">{{$t('merchant.more-detail')}}</p>
		    	</div>
		    </template>
	    </div>
	    <template v-if="showVariant">
	    	<template v-for="(item,index) in ticket.variants">
					<ticket-variant :data="item" :ticket="ticket" @reset-item="transportChangeData('unselected')" :is_border="(index+1) != ticket.variants.length"></ticket-variant>
				</template>
	    </template>
	    <div class="pt-3" :class="{'border-top':show_variant}">
	      <div class="row slim-grid-row">
	      	<!-- display when ticket type is activities or transport but one away trip type -->
			    <template v-if="changeBottomArea">
		        <div class="col-7">
		        	<template v-if="ticket.variants[0].discount == 0">
		        		<p class="mb-0 mt-2 sub-heading-1-2 text-color-orange">{{formatCurrency(ticket.variants[0].price_sell_discount)}}</p>
		        	</template>
		        	<template v-else>
		            <p class="mb-0 body-1-3 text-line-through" style="color: #00000073" @click="resetCart()">{{formatCurrency(ticket.variants[0].price_sell)}}</p>
		            <p class="mb-0 sub-heading-1-2 text-color-orange">{{formatCurrency(ticket.variants[0].price_sell_discount)}}</p>
		        	</template>
		        </div>
		        <div class="col-5">
		      		<button v-if="!is_available" class="btn w-100 body-2-4 rounded-10 py-2 text-center text-green" style="background-color: #EFEFEF;height: 47px;" >{{$t('merchant.out-of-stock')}}</button>
		        	<template v-else>
		            <button v-if="!return_custom_show" class="bg-orange btn w-100 body-2-4 rounded-10 py-2 text-center text-white" style="height: 47px;" @click="addItem()">{{$t('general.select')}}</button>
		            <button v-else class="btn w-100 body-2-4 rounded-10 py-2 text-center text-green"
		            style="background-color: #EFEFEF;height: 47px;" @click="toggleWarningReset()">{{$t('general.cancel')}}</button>
		        	</template>
		        </div>
		      </template>
		      <template v-else>
		      	<div class="col-6">
		      		<button v-if="!getTicketTransportReturn()" class="bg-green btn w-100 body-2-4 rounded-10 py-2 text-center text-white" style="height: 47px;" @click="toggleVariant('hide')">{{$t('merchant.select-return')}}</button>
		      		<button v-if="getTicketTransportReturn()" class="bg-green btn w-100 body-2-4 rounded-10 py-2 text-center text-white" style="height: 47px;" @click="toggleVariant('show')">{{$t('merchant.change-variant')}}</button>
		      	</div>
		      	<div class="col-6">
		      		<button class="btn w-100 body-2-4 rounded-10 py-2 text-center text-green"
		            style="background-color: #EFEFEF;height: 47px;" @click="toggleWarningReset()">{{$t('general.cancel')}}</button>
		      	</div>
		      </template>
	      </div>
	    </div>
	    <warning-box 
	    	v-if="warning_reset_item_show"  
	    	@no="toggleWarningReset" 
	    	@yes="resetItem"
	    	:title="$t('warning-message.reset-item.title')"
				:body="$t('warning-message.reset-item.message')"
				:btn_primary="$t('general.yes-delete')"
				:btn_secondary="$t('general.cancel')">	
	    	</warning-box>
		</div>
	</div>
</template>
<script>
	import moment from 'moment';
	import {formatCurrency,inputCustomOnly} from '@/utils/index.js';
	import {mapGetters, mapActions,mapMutations} from "vuex";
	import {get} from '@/services/index.js';
	import TicketVariant from '@/components/ticket/TicketVariant';
	import WarningBox from '@/components/general/WarningBox'

	export default{
		props:{
			data :{
				type: Object
			},
			is_variant:{
				type: Boolean,
				default: true
			}
		},
		components:{
			TicketVariant,
			WarningBox
		},
		data(){
			return{
        show_variant: false,
        return_custom_show: false,
        ticket: {},
        is_available: false,
        warning_reset_item_show: false,
        show_return_list: false
			}
		},
		created(){
			this.checkQtyVariant();
		},
		computed:{
			CartItemQty(){
				return this.getTicketCart().qty;
			},
			changeBottomArea(){
				let data = false
				let ticket_select = this.getTicketCart().ticket_details.find(x=>x.ticket.id == this.data.id)
				if(this.getMerchant().merchant_category_name == 'ACTIVITIES' || ticket_select == undefined || !this.is_variant){
					data = true
				}else if(this.getMerchant().merchant_category_name == 'TRANSPORT'){
					if(this.getTicketFilter().trip_type == 'one_away'){
						data = true
					}else{
						data = false
					}
				}else{
					data = false
				}
				return data;
			},
			show_validity_term(){
				if (this.ticket.variants[0].validity_term == null || this.ticket.variants[0].validity_term == ''){
					return false
				}else{
					return true
				}
			},
			showVariant(){
				if(this.show_variant && this.is_variant){
					if(this.getMerchant().merchant_category_name == 'ACTIVITIES') return true
					else if(this.getMerchant().merchant_category_name == 'TRANSPORT' && !this.getTicketTransportReturn()){
						return true
					}else{
						return false
					}
				}else{
					return false
				}
			}
		},
		watch:{
			CartItemQty(){
				this.checkQtyVariant()
			}
		},
		methods:{
			...mapGetters(['getTicketCart','getMerchant','getTicketFilter','getTicketTransportReturn']),
			...mapActions(['ticketAddItemCart','ticketClearItemCart','setMerchant']),
      ...mapMutations(['ticketSetTransportReturn','tickcetAddItemDirect']),
			inputCustomOnly($event,value){
				inputCustomOnly(value,$event)
			},
			formatTime(time){
				return moment(time,'HH:mm:ss').format("HH:mm")
			},
			formatDuration(start,end,as){
				let start_formatted = moment(start,"HH:mm:ss")
				let end_formatted = moment(end,"HH:mm:ss")
				if(as == 'H'){
					return moment.duration(end_formatted.diff(start_formatted)).hours()
				}else{
					return moment.duration(end_formatted.diff(start_formatted)).minutes()	
				}
			},
			formatCurrency(data){
				return formatCurrency(data)
			},
			checkQtyVariant(){
				this.ticket = JSON.parse(JSON.stringify(this.data));
				this.checkTicketAvailability();
				let variant_details = this.getTicketCart().ticket_details;
				if (variant_details) {
					this.show_variant = false
					this.return_custom_show = false
					for(let j = 0; j < variant_details.length; j++){
						if (this.ticket.id == variant_details[j].ticket.id) {
							this.show_variant = true
							this.return_custom_show = true
							break;
						}
					}
				}else{
					this.show_variant = false
					this.return_custom_show = true
				}
			},
			checkTicketAvailability(){
				if(this.getMerchant().merchant_category_name == 'TRANSPORT'){
					this.is_available = (this.ticket.min_availability > 0) ? true : false
				}else{
					for(let i = 0; i < this.ticket.variants.length; i++){
						if (this.ticket.variants[i].availability > 0) {
							this.is_available = true;
							break;
						}
					}
				}
			},
			transportChangeData(type){
				if(type=='selected') this.$emit("transport-selected")
				else this.$emit("transport-unselected")
			},
			resetItem(){
				if(this.getMerchant().merchant_category_name == 'TRANSPORT'){
					this.transportChangeData('unselected')
					// if(this.ticket.ticket_transport_type == 'departure' && this.getTicketCart().ticket_details.length > 1){
					// 	this.ticketClearItemCart(this.getTicketCart().ticket_details[1].ticket)
					// }
				}
				this.ticketClearItemCart(this.ticket)
				this.toggleWarningReset()
			},
			toggleWarningReset(){
				this.warning_reset_item_show = !this.warning_reset_item_show
			},
			addItem(){
				if(this.getMerchant().merchant_category_name == 'TRANSPORT'){
					this.transportChangeData('selected')
					if(this.ticket.ticket_transport_type == 'return'){
						// let copied_data = Object.assign({}, this.ticket)
						let data = {
							ticket: this.ticket,
							variant: []
						}
						let ticket_variant_departure = this.getTicketCart().ticket_details[0].variant
						for(let i = 0; i < ticket_variant_departure.length;i++){
							let return_variant = this.ticket.variants.find(x=> x.variant_id == ticket_variant_departure[i].data.variant_id)
							data.variant.push({
								data: return_variant,
								qty: ticket_variant_departure[i].qty
							})
						}
						delete data.ticket.variants
						this.tickcetAddItemDirect(data)

					}else{
						this.addVariantToCart()
					}
				}else{
					this.addVariantToCart()
				}
			},
			changeMerchant(){
				get("CORE","merchant/"+this.$route.params.merchant_code).then(response=>{
          let res = response.data
          this.setMerchant({type:'fill',data: res.data})
          this.addVariantToCart()
        })
			},
			addVariantToCart(){
				if(this.getMerchant().merchant_category_name == 'TRANSPORT'){
					let data = {
						ticket: this.ticket,
						variant: this.ticket.variants[0]
					}
					delete data.ticket.variants
					this.ticketAddItemCart(data)
				}else{
					for(let i = 0; i < this.ticket.variants.length; i++){
						if (this.ticket.variants[i].availability > 0) {
							
							let data = {
								ticket: this.ticket,
								variant: this.ticket.variants[i]
							}
							delete data.ticket.variants
							this.ticketAddItemCart(data)

							break;
						}
					}
				}
			},
			goDetail(){
				this.$router.push({
					path: '/'+this.getMerchant().code+'/list/'+this.data.id
				})
			},
			showReturn(){
				this.show_variant = false
			},
			toggleVariant(type){
				if(type == 'show'){
					this.show_variant = true
					this.ticketSetTransportReturn(false)
					if(this.getTicketCart().ticket_details.length > 1){
						this.ticketClearItemCart(this.getTicketCart().ticket_details[1].ticket)
					}
				}else{
					this.$emit('load-return')
					this.show_variant = false
				}
			}
		}
	}
</script>
<style scoped>
	.destinations-dot{
		height: 37px;
		border-left: 1px dashed rgb(210, 206, 206);
		border-right: 1px dashed rgb(210, 206, 206);
		width:0px;
	}
	.test-box-shadow{
		box-shadow: 0 1px 5px 0 rgba(0,0,0,0.2);
	}
  .break {
    background-color: #e9ebf2;
    height: 6px;
    border-top: 1px solid #e2e2e2;
  }

  .color-black {
    color: #000 !important;
  }

  .color-bold-light {
    color: #000000A6;
  }

  .plus-min-set input {
    margin-top: 10px;
  }

  .w-85{
  	width: 85% !important;
  }

	@media only screen and (max-width: 321px){
    .counter{
      width: 25px !important;
    }
  }

  /*@media only screen and (min-width: 600px){
    .counter{
      text-align: right !important;
    }
  }*/
</style>


// WEBPACK FOOTER //
// src/components/ticket/Ticket.vue